import { createContext, useContext, ReactNode } from "react";

interface SeoContextType {
  title: string;
  description: string;
  url: string;
  shareImage: string;
  keywords: string;
  preventIndexing: boolean;
}

const defaultSeoContext: SeoContextType = {
  title: "Default Title",
  description: "Default Description",
  url: "",
  shareImage: "",
  keywords: "",
  preventIndexing: false,
};

export const SeoContext = createContext<SeoContextType>(defaultSeoContext);

interface SeoProviderProps {
  children: ReactNode;
  value: Partial<SeoContextType>;
}

export const SeoProvider = ({ children, value }: SeoProviderProps) => {
  const contextValue = {
    ...defaultSeoContext,
    ...value,
  };

  return (
    <SeoContext.Provider value={contextValue}>{children}</SeoContext.Provider>
  );
};

export const useSeo = () => useContext(SeoContext);
